import api from "./core";

const basePath = "api/core/CollaborateMD";

export default {
  isActive() {
    return api.get(`${basePath}/IsActive`);
  }
};
